<quill-editor
  #editor
  [placeholder]="placeholder"
  [modules]="quillConfig"
  [bounds]="bounds"
  [styles]="quillStyles"
  [formControl]="inputFC"
  (onEditorCreated)="onEditorCreated($event)"
  (onEditorChanged)="onEditorChanged($event)"
  (onFocus)="onEditorFocus($event)"
  (click)="onQuillClickFn($event)"
  [readOnly]="isReadOnly"
  [class]="class"
>
  @if (showToolbar) {
    <div quill-editor-toolbar class="quill-toolbar">
      <button class="ql-header h1-icon" value="1"></button>
      <button class="ql-header h2-icon" value="2"></button>
      <button class="ql-bold bold-icon"></button>
      <button class="ql-italic italic-icon"></button>
      <button class="ql-underline underline-icon"></button>
      <button class="ql-list list-icon" value="bullet"></button>
      <button class="ql-link link-icon"></button>
      <button class="ql-image image-icon"></button>
      <button class="ql-clean clean-icon"></button>
    </div>
  }
</quill-editor>
